const getters = {
  // 数据字典
  dict_datas: (state) => state.dict.dictDatas,
  // 无路由的面包屑展示
  breadcrumbData: (state) => state.breadcrumb.breadcrumbData,
  // token
  token: (state) => state.user.token,
};
export default getters;
